import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBand } from './components/TrustBand';
import { CategorySection } from './components/CategorySection';
import { FeaturedProducts } from './components/FeaturedProducts';
import { WorkshopSection } from './components/WorkshopSection';
import { CustomWork } from './components/CustomWork';
import { StorySection } from './components/StorySection';
import { FaqSection } from './components/FaqSection';
import { ClosingCta } from './components/ClosingCta';
import { Footer } from './components/Footer';
const TITLE = 'Metal Shaping Tools & Workshops | Fournier Enterprises';
const DESCRIPTION = 'Shop metal shaping tools, English wheels and fabrication equipment. Explore hands-on workshops and custom metalwork in Mt. Clemens, Michigan.';
export function App() {
  useEffect(() => {
    document.title = TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', DESCRIPTION);
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3rbrcwx2qabiz">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-charcoal focus:px-4 focus:py-2 focus:text-white" data-id="element-1" data-mp="3rcsuzli5vya7">
        Skip to content
      </a>
      <Header data-id="element-2" data-mp="2zng2amkvootz" />
      <main id="main" data-id="element-3" data-mp="33mf2jtvnzxf3">
        <Hero data-id="element-4" data-mp="33lx0uhq8gqzs" />
        <TrustBand data-id="element-5" data-mp="33nggq77z9011" />
        <CategorySection data-id="element-6" data-mp="33mylndx1wrup" />
        <FeaturedProducts data-id="element-7" data-mp="38lrqkhy9vaj9" />
        <WorkshopSection data-id="element-8" data-mp="38li7zffk45nl" />
        <CustomWork data-id="element-9" data-mp="38k6ugnwb7jja" />
        <StorySection data-id="element-10" data-mp="38nuqput52k1p" />
        <FaqSection data-id="element-11" data-mp="3dkl3o99ncziw" />
        <ClosingCta data-id="element-12" data-mp="3dl4mds74frxz" />
      </main>
      <Footer data-id="element-13" data-mp="3dmfn1j59sjkv" />
    </div>;
}